module.exports = __webpack_public_path__ + "img/google-square.9396f64a.svg";